<template>
  <div class="bottom" @click.stop :class="{
    hide: $store.state.hideBottom,
  }">
    <div v-if="$store.state.hideBottom" class="open" @click="onClick(false)">
      <img :src="downIcon" style="transform: rotate(-180deg)" />
    </div>
    <div v-else class="close" @click="onClick(true)">
      <img :src="downIcon" />
    </div>
    <PlayBack />
    <Matrix />
    <Dashboard />
    <Module2 :statusInfos="statusInfos" />
    <Varguard />
    <NewProgress 
      :getPlayInfo="getTags" 
      :tags="tags" 
      :varguardError="varguard_error" 
      :varguardFatal="varguard_fatal" 
      :varguardFristFatal="varguard_resets" 
      :alarmCodeList="alarmCodeList"
      :operationLog="operationLogList" />
  </div>

  <!--  自动引入占位-->
  <el-row v-if="false">
    <el-form></el-form>
    <el-col></el-col>
    <el-date-picker />
    <el-upload />
    <el-icon />
    <el-image />
    <el-tooltip />
    <el-empty />
    <el-slider />
    <el-dialog />
    <el-notification />
    <el-radio />
  </el-row>
</template>

<script>
import { defineComponent, ref } from 'vue';
import Dashboard from './component/Dashboard/index.vue';
import Module from './component/Module/index.vue';
import PlayBack from './component/PlayBack/index.vue';
import Trafficlight from './component/Trafficlight/index.vue';
import CameraControl from './component/CameraControl/index.vue';
import NewProgress from '@/views/Home/component/Bottom/component/NewProgress/index.tsx';
import { useStore } from '@/store/index';
import { getPlayInfo,getAlarmCodeList,getVehicleOperationLog } from '@/service';
import { BUSINESS_INSTRUCTION_TYPE_CODES } from '@/constants/vehicleOperationLog';
import FormSwitch from './component/FormSwitch/index.tsx';
import Matrix from '@/views/Home/component/Bottom/component/Matrix/index.tsx';
import Varguard from '@/components/Varguard/index.vue';
import Module2 from './component/Module2/index.tsx';
import downIcon from '@/assets/images/down.png';
import { dayjs } from 'element-plus';

export default defineComponent({
  name: 'Bottom',
  components: {
    Varguard,
    Matrix,
    FormSwitch,
    Dashboard,
    Trafficlight,
    CameraControl,
    Module,
    PlayBack,
    NewProgress,
    Module2,
  },
  setup() {
    const store = useStore();

    const tags = ref([]);//标签；
    const statusInfos = ref([]);//速度
    const varguard_error = ref([]);//error 类型的varguard
    const varguard_fatal = ref([]);//fatal 类型的varguard
    const varguard_resets = ref([]);//fatal droving=varguard nonal 后的第一个fatal
    const alarmCodeList = ref([]);//alarmCode列表
    const operationLogList = ref([]);//车辆操作日志（一键挪车等）

    const onClick = (bool) => {
      store.commit('changeHideBottom', bool);
    };

    const getTags = (vehicleId, startTs, endTs) => {
      if(store.state.checkedEventTags.length){
        store.commit('setCheckedEventTags',[])
      }
      if(store.state.checkedAlarmCodeList.length){
        store.commit('setCheckedAlarmCode',[])
      }
      getPlayInfo({
        vehicleName: vehicleId,
        startTs,
        endTs,
      }).then((res) => {
        const { statusInfos: status,errors,faults,resets } = res.data;
        varguard_error.value = errors;
        varguard_fatal.value = faults;
        varguard_resets.value = resets;
        statusInfos.value = status;
      }).then(() => {
        getAlarmCodeList({
          vehicleName: vehicleId,
          startTime:dayjs(startTs).format('YYYY-MM-DD HH:mm:ss'),
          endTime:dayjs(endTs).format('YYYY-MM-DD HH:mm:ss'),
        }).then((res) => {
          alarmCodeList.value = res.data;
          store.commit('setAlarmCodeList',alarmCodeList.value);
        })
      }).then(() => {
        getVehicleOperationLog({
          vehicleName: vehicleId,
          startTime: dayjs(startTs).format('YYYY-MM-DD HH:mm:ss'),
          endTime: dayjs(endTs).format('YYYY-MM-DD HH:mm:ss'),
          instructionTypeCode: BUSINESS_INSTRUCTION_TYPE_CODES,
        }).then((res) => {
          operationLogList.value = res?.data?.list || [];
        }).catch(() => {
          operationLogList.value = [];
        })
      })
    };

    return {
      onClick,
      getTags,
      tags,
      varguard_error,
      varguard_fatal,
      varguard_resets,
      statusInfos,
      downIcon,
      alarmCodeList,
      operationLogList
    };
  },
});
</script>
<style lang="less">
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  transition: background 0.3s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
}

::-webkit-scrollbar-thumb:active {
  background: rgba(255, 255, 255, 0.6);
}

.el-slider__marks-stop {
  background-color: rgb(163, 162, 163);
}

.el-slider__marks-text {
  margin-top: 0;
}

.el-slider__bar {
  /* background-color: #1efff7 !important; */
  background-color: transparent;
}

.el-slider__runway {
  opacity: 0.8;
  border: #fff 2px solid;
  background-color: transparent;
  /* background-color: rgb(255, 255, 255); */
  &::before {
      content: '';
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
  }
}

.el-slider__button {
  border: none;
  background-color: #1efff7;
  box-shadow: 0 2px 6px 0 #00000066;
}

.control {
  .el-select {
    width: 200px;
    height: 28px;
    border: none;
    background: #67818a;
    border-radius: 4px;

    input {
      border: none;
    }
  }

  .select-trigger {
    width: 200px;
    height: 28px;
    border: none;
    background: #67818a;
    border-radius: 4px;
  }

  .el-input {
    width: 200px;
    height: 28px;
    border: none;
    background: #67818a;
    border-radius: 4px;
  }

  .el-input__wrapper {
    border: none;
    background: #67818a;
    box-shadow: none !important;
  }

  .el-input__inner {
    color: #fff;
    border: 0 !important;
  }
}
</style>
<style lang="less" scoped>
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 240px;
  transition: all 0.3s;
  user-select: none;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #021a2c;
  border: none;
}

&.hide {
  bottom: -240px;
}

.open,
.close {
  position: absolute;
  left: 50%;
  top: -94px;
  width: 80px;
  transform: translateX(-50%);
  height: 40px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  img {
    width: 60px;
  }
}

.playback {

  .open,
  .close {
    top: -60px;
  }
}

.w58 {
  width: 60%;
  height: 100%;
}
</style>
